import { Constant, Headers } from "../apiConstants";

const PaymentStatusAPI = async (params) => {
  const endpoint = Constant.PAYMENT_STATUS;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify({
        bankName: params.bankName,
        order_id: params.paymentRefNumber || params.order_id,
        razorpay_payment_id: params.payment_id,
        razorpay_amount: params.amount,
        paymentType: params.type,
        payment_link_reference_id: params.reference_id,
        payment_link_id: params.link_id,
        payment_status: params.status,
        razorpay_signature: params.signature,
      }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default PaymentStatusAPI;
